<template>
  <div
    v-if="jobsStore?.regions?.length > 0 || jobsStore?.tags?.length > 0"
    class="flext flex-col md:flex-row items-center md:items-end justify-between md:justify-center gap-6 md:gap-4 my-16 lg:my-8 relative"
  >
    <MultiselectOptionsComponent
      v-if="jobsStore?.regions?.length > 0"
      class="w-72"
      :items="jobsStore?.regions"
      :selected-label="LANG.selectedItems?.[jobsStore.lang]"
      :label="LANG.regions?.[jobsStore.lang]"
      @update="(options) => (regions = options.map((o) => o.Value as number))"
    />

    <MultiselectOptionsComponent
      v-if="jobsStore?.tagsWithCounter?.length > 0"
      class="w-72"
      :items="jobsStore?.tagsWithCounter"
      :selected-label="LANG.selectedItems?.[jobsStore.lang]"
      :label="LANG.tags?.[jobsStore.lang]"
      @update="(options) => (tags = options.map((o) => o.Value as string))"
    />

    <BaseButtonAlt
      class="w-auto"
      @click="!jobsStore.loading && emits('search', { tags, regions })"
    >
      {{ LANG.search?.[jobsStore.lang] }}
    </BaseButtonAlt>
  </div>
  <div v-else class="h-64"></div>
</template>

<script setup lang="ts">
import { useJobs } from '~/store/useJobs';
import { LANG } from '@/config/lang';

const jobsStore = useJobs();
const tags = ref<string[]>([]);
const regions = ref<number[]>([]);

const emits = defineEmits<{
  search: [value: { tags: string[]; regions: number[] }];
}>();
</script>

<style scoped></style>
